// extracted by mini-css-extract-plugin
module.exports = {"header-title":"CommonFrame_header-title__2AmAo","header":"CommonFrame_header__2gYGg"};